import { useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const validateContact = ({ name, mobile, email }, consent) => {
  const e = {};
  if (!name.trim()) e.name = "Please enter your name";
  if (!/^[0-9+\-\s]{8,15}$/.test(mobile.trim())) e.mobile = "Enter a valid mobile number";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) e.email = "Enter a valid email";
  if (!consent) e.consent = "Please accept to continue";
  return e;
};

// Shared state + submit logic for any contact-capturing form
export const useLeadForm = (initial, buildPayload, { endpoint = "/leads", onSuccess } = {}) => {
  const [form, setForm] = useState(initial);
  const [consent, setConsentState] = useState(false);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [leadId, setLeadId] = useState(null);
  const [serverError, setServerError] = useState("");

  const set = (k, v) => {
    setForm((f) => ({ ...f, [k]: v }));
    if (errors[k]) setErrors((e) => ({ ...e, [k]: null }));
  };

  const setConsent = (v) => {
    setConsentState(v);
    if (errors.consent) setErrors((e) => ({ ...e, consent: null }));
  };

  const submit = async (ev) => {
    ev.preventDefault();
    const e = validateContact(form, consent);
    setErrors(e);
    if (Object.keys(e).length) return;
    setStatus("loading");
    setServerError("");
    try {
      const { data } = await axios.post(`${API}${endpoint}`, buildPayload(form));
      setLeadId(data.id);
      setStatus("success");
      onSuccess?.(data);
    } catch (err) {
      const d = err.response?.data?.detail;
      setServerError(typeof d === "string" ? d : "");
      setStatus("error");
    }
  };

  return { form, set, consent, setConsent, errors, status, leadId, serverError, submit };
};
